import { render, staticRenderFns } from "./Wikipedia-articles.vue?vue&type=template&id=d0e8bd5c&scoped=true&"
import script from "./Wikipedia-articles.vue?vue&type=script&lang=js&"
export * from "./Wikipedia-articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e8bd5c",
  null
  
)

export default component.exports